

















































































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Shopify } from "../models/Shopify";
export default Vue.extend({
  mixins: [pagination, dialog, permission],
  data() {
    const shopifyWebhook = "";
    const mycloudWebhook = "";
    const isShowCilpboardDialog = false;
    const shopsShopify: Shopify[] = [];
    return {
      shopsShopify,
      isShowCilpboardDialog,
      shopifyWebhook,
      mycloudWebhook
    };
  },
  computed: {
    hasCreateShopifyPermission() {
      return (this as any).hasPermission(PermissionName.SHOPIFY_CREATE);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getShopsShopify()]);
  },
  methods: {
    async getShopsShopify() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.shopifyUseCase.getShopify(form);
        this.shopsShopify = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShopifyCreatePage() {
      this.$router.push({ name: "ShopifyCreatePage" });
    },
    goToShopifyUpdatePage(id: any) {
      this.$router.push({ name: "ShopifyUpdatePage", params: { id } });
    },
    async syncProductDialog(shopify: Shopify) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync สินค้า",
        `คุณต้องการที่จะ Sync สินค้าร้าน ${shopify.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncProduct(shopify.shopId!);
      }
    },
    async syncProduct(id: number) {
      try {
        await (this as any).$dep.shopifyUseCase.syncProductByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync สินค้าแล้ว");
        this.getShopsShopify();
      } catch (error) {
        console.log(error);
      }
    },
    async syncStockDialog(shopify: Shopify) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync Stock",
        `คุณต้องการที่จะ Sync Stock ร้าน ${shopify.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncStock(shopify.shopId!);
      }
    },
    async syncStock(id: number) {
      try {
        await (this as any).$dep.shopifyUseCase.syncStockByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync Stock แล้ว");
        this.getShopsShopify();
      } catch (error) {
        console.log(error);
      }
    },
    async deleteShopifyDialog(shopify: Shopify) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบ Shopify",
        `คุณต้องการที่จะลบ Shop ${shopify.shopName} ใช่ไหม?`
      );
      if (isComfirmed) {
        this.deleteShopify(shopify.id!);
      }
    },
    async deleteShopify(id: number) {
      try {
        await (this as any).$dep.shopifyUseCase.deleteShopify(id);
        (this as any).alertSuccess("Success", "ลบ Shopify สำเร็จ");
        this.getShopsShopify();
      } catch (error) {
        console.log(error);
      }
    }
  }
});
